/* sr-offer-three-hours: progressive enhancement for the three-hour block's offer page. Without it the
   page still reads and works: the hero shows this visit's poster and every link is a plain link.
   The hero film logic is the homepage's (sr-home-w2.js), scoped to .sro3. */
(function () {
  function init() {
    var root = document.querySelector('.sro3');
    if (!root) { return; }
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hero = root.querySelector('.sro3-hero');

    /* ---------- First screen ----------
       --sro3-top: the height of everything in flow above the hero (the promo bar and the header, both
       rendered inside .sro3); the hero runs up under them by that much and still fills the rest of the
       first screen. --sro3-copy: how far the copy reaches up from the
       hero's bottom, which sizes the phone gradient. Measured on load and on width change only, so a
       phone's toolbar sliding away never resizes the hero mid-scroll. */
    var fitW = 0;
    function fit(force) {
      if (!hero || (!force && window.innerWidth === fitW)) { return; }
      fitW = window.innerWidth;
      var top = 0, el = hero.previousElementSibling;
      for (; el; el = el.previousElementSibling) {
        var cs = getComputedStyle(el);
        if (cs.display === 'none' || cs.position === 'fixed' || cs.position === 'absolute') { continue; }
        top += el.getBoundingClientRect().height;
      }
      if (top >= 0 && top < 400) { root.style.setProperty('--sro3-top', Math.ceil(top) + 'px'); }
      var copy = hero.querySelector('.sro3-hero__content');
      if (copy) {
        var hb = hero.getBoundingClientRect().bottom, ct = copy.getBoundingClientRect().top;
        if (hb - ct > 40) { root.style.setProperty('--sro3-copy', Math.round(hb - ct) + 'px'); }
      }
    }
    fit(true);
    window.addEventListener('load', function () { fit(true); });
    window.addEventListener('resize', function () { fit(false); }, { passive: true });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { fit(true); }); }

    /* ---------- Hero quotes (Buyback, 2026-10-24) ----------
       On phones the two client quotes are one swiped row. While the row actually scrolls it takes a
       Tab stop, so keyboard users can reach the second quote; on wider screens it is a plain row. */
    var quotes = root.querySelector('.sro3-hero__quotes');
    function quotesTab() {
      if (!quotes) { return; }
      if (quotes.scrollWidth > quotes.clientWidth + 2) { quotes.setAttribute('tabindex', '0'); }
      else { quotes.removeAttribute('tabindex'); }
    }
    quotesTab();
    window.addEventListener('resize', quotesTab, { passive: true });

    /* ---------- Header: transparent over the film at the top, solid once scrolled ----------
       Ported from sr-home-w2.js: past 56px of scroll .sro3-head-solid turns the header and the promo
       bar solid (sr-offer-three-hours.css). The page can scroll inside .page-wrapper, so both count. */
    var wrapEl = document.querySelector('.page-wrapper'), solid = null, hf = 0;
    function head() {
      hf = 0;
      var y = Math.max(window.pageYOffset || 0, wrapEl ? wrapEl.scrollTop : 0);
      var s = y > 56;
      if (s !== solid) { solid = s; root.classList.toggle('sro3-head-solid', s); }
    }
    head();
    document.addEventListener('scroll', function () { if (!hf) { hf = requestAnimationFrame(head); } }, { capture: true, passive: true });

    /* ---------- Phone dock clearance ----------
       The site's fixed gold dock covers the bottom of a phone screen; its real footprint feeds
       --sro3-dock, the extra foot room on each band. The dock is hidden until the visitor scrolls,
       so keep trying on scroll until it has a size. */
    var dockDone = false, df = 0;
    function measureDock() {
      var dock = document.querySelector('.sr-mobile-dock');
      if (!dock || dock.hidden) { return; }
      var cs = getComputedStyle(dock);
      if (cs.display === 'none' || cs.position !== 'fixed') { return; }
      var h = Math.ceil(dock.getBoundingClientRect().height + (parseFloat(cs.bottom) || 0) + 12);
      if (h > 30 && h < 160) { root.style.setProperty('--sro3-dock', h + 'px'); dockDone = true; }
    }
    window.addEventListener('load', measureDock);
    document.addEventListener('scroll', function () {
      if (!dockDone && !df) { df = requestAnimationFrame(function () { df = 0; measureDock(); }); }
    }, { capture: true, passive: true });

    /* ---------- Hero film ----------
       Muted, looping, plays only while on screen. Reduced motion and data saver never fetch a video
       byte: the poster is a frame of the work. The pause control is offered while the film runs
       (WCAG 2.2.2). */
    var v = root.querySelector('.sro3-hero__video');
    if (!v) { return; }
    var btn = root.querySelector('.sro3-hero__toggle');
    var save = navigator.connection && navigator.connection.saveData;
    var small = window.matchMedia('(max-width: 760px)').matches;
    if (reduce.matches || save) { return; }
    v.muted = true;
    v.loop = true;
    v.src = small ? v.getAttribute('data-src-sm') : v.getAttribute('data-src-lg');
    /* the film fades in over its <img> poster once it is really painting frames; if autoplay is
       refused (Low Power Mode) it never does, and the poster simply stays */
    v.addEventListener('playing', function on() { v.classList.add('is-on'); v.removeEventListener('playing', on); });
    v.preload = 'auto';
    var userPaused = false;
    function setBtn(paused) {
      if (!btn) { return; }
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Play the film' : 'Pause the film');
    }
    function play() {
      var p = v.play();
      if (p && p.catch) { p.catch(function () { setBtn(true); }); }
      setBtn(false);
    }
    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        if (v.paused) { userPaused = false; play(); } else { userPaused = true; v.pause(); setBtn(true); }
      });
    }
    /* a rect check on scroll: on this theme the page can scroll inside .page-wrapper, so scroll
       events are captured from any element */
    function check() {
      var r = v.getBoundingClientRect();
      if (!r.height) { return; }
      var seen = (Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0)) / r.height;
      if (seen >= .15) { if (!userPaused && v.paused) { play(); } }
      else if (!v.paused) { v.pause(); }
    }
    var f = 0;
    function sched() { if (!f) { f = requestAnimationFrame(function () { f = 0; check(); }); } }
    document.addEventListener('scroll', sched, { capture: true, passive: true });
    window.addEventListener('resize', sched, { passive: true });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { sched(); } });
    v.addEventListener('loadeddata', check);
    check();
    reduce.addEventListener('change', function () { if (reduce.matches) { userPaused = true; v.pause(); setBtn(true); } });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
